import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

export type ContactTopicValue =
    | "product"
    | "enterprise"
    | "support"
    | "partnership"
    | "other";

export interface ContactSubmitBody {
    name: string;
    email: string;
    phone?: string;
    topic: ContactTopicValue;
    message: string;
}

export interface ContactSubmitResponse {
    status: "sent";
}

@Injectable({
    providedIn: "root",
})
export class ContactService {
    constructor(private readonly http: HttpClient) {}

    submit(body: ContactSubmitBody): Observable<ContactSubmitResponse> {
        const url = `${environment.apiUrl}/contact`;
        return this.http.post<ContactSubmitResponse>(url, body);
    }
}
